<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed" [formGroup]="internalAccessForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="form-group">
        <kt-alert *ngIf="hasErrorConflict" type="warn" [showCloseButton]="false" [duration]="10000">
          <span>Oh snap! This Team is already added, try to edit the access.</span>
        </kt-alert>
        <kt-general-autocomplete
          [appearance]="'fill'"
          [label]="'Teams'"
          [loadItemsFunction]="categoryAutocompleteCall"
          [optionFormatter]="stringUtils.displayTeamName"
          [valueFormatter]="stringUtils.displayTeamName"
          [required]="true"
          [readOnly]="data.mode === 'UPDATE'"
          [control]="internalAccessForm.get('teams')"
          [change]="onCategoryChange.bind(this)"
          [dataPath]="'data'"
          [placeholder]="'Select Teams'"
          #categoryAutocomplete
        ></kt-general-autocomplete>
        <div>
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Page Group</mat-label>
            <mat-chip-list #chipList required formControlName="pages">
              <mat-chip
                color="primary"
                selected
                (click)="$event.stopPropagation()"
                *ngFor="let p of selectedPages"
                (removed)="remove(p)"
              >
                {{ p.name }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <input
                matInput
                (click)="$event.stopPropagation()"
                placeholder="Select page..."
                [matChipInputFor]="chipList"
                #pagess
                formControlName="pages"
                required
                [matAutocomplete]="auto1"
              />
            </mat-chip-list>
            <mat-autocomplete
              #auto1="matAutocomplete"
              [displayWith]="pageFn"
              (optionSelected)="selected1($event)"
            >
              <mat-option
                *ngFor="let page of optionPages"
                [value]="page"
                [disabled]="isSelected(page)"
                (click)="$event.stopPropagation()"
              >
                <span> {{ page.name }} </span>
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('pages', 'required')">
              Page Group is
              <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
        <div>
          <div class="row ml-2">
            <label>Rule:</label>
            <span style="color: red">*</span>
          </div>
          <mat-radio-group class="ml-2" [(ngModel)]="rule" [ngModelOptions]="{ standalone: true }">
            <mat-radio-button value="VIEWER">Viewer</mat-radio-button>
            <mat-radio-button value="CREATOR">Creator</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button (click)="close()" type="button" mat-raised-button matTooltip="Cancel">
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            [disabled]="!rule"
            (click)="onSubmit()"
            matTooltip="Save"
          >
            <span>Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
